import { useEffect, useState } from 'react';

/**
 * Exit animace pro modaly/dialogy. Vrátí `true` ještě `duration` ms po
 * přepnutí open→false, takže komponenta zůstane namountovaná a CSS exit
 * animace doběhne před skutečným unmountem.
 *
 * Použití:
 *   const exiting = useExitAnimation(open);
 *   if (!open && !exiting) return null;
 *   // na backdrop:  open ? 'animate-backdropIn'  : 'animate-backdropOut'
 *   // na dialog:    open ? 'animate-modalIn'    : 'animate-modalOut'
 */
export function useExitAnimation(open: boolean, duration = 160): boolean {
  const [exiting, setExiting] = useState(false);
  const [prevOpen, setPrevOpen] = useState(open);

  // Detekce přechodu open→false při renderu (React-endorsed "adjusting state
  // when props change" pattern) — spustí exit fázi bez potřeby sync setState
  // v efektu.
  if (open !== prevOpen) {
    setPrevOpen(open);
    setExiting(!open);
  }

  useEffect(() => {
    if (!exiting) return;
    const t = setTimeout(() => setExiting(false), duration);
    return () => clearTimeout(t);
  }, [exiting, duration]);

  return exiting;
}
